// extracted by mini-css-extract-plugin
module.exports = {"matchLiveTickerMainContainer":"style_matchLiveTickerMainContainer__xf_sV","eventsContainer":"style_eventsContainer__5yEnT","eventRow":"style_eventRow__gbFde"};